import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Success = ({ message }) => {
  toast.success(
    <div className="text-black">
      <p>{message}</p>
    </div>,
    {
      position: "top-center",
      autoClose: 2000,
      theme: "light",
      progressBarColor: "red",
  
    }
  );
};

export default Success;
